import { GoToMembershipSettingsCTA } from "./ctas";
export var PauseMembershipIA = function PauseMembershipIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return PAUSE_YOUR_INSIDER_MEMBERSHIP(strictLocalize);
    },
    getDescription: function getDescription() {
      return [IF_YOU_WOULD_LIKE_TO_PAUSE_YOUR_MEMBERSHIP(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToMembershipSettingsCTA(strictLocalize);
};
var PAUSE_YOUR_INSIDER_MEMBERSHIP = function PAUSE_YOUR_INSIDER_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "FMI5i9",
    defaultMessage: [{
      "type": 0,
      "value": "Suspender a sua subscrição Insider"
    }]
  });
};
var IF_YOU_WOULD_LIKE_TO_PAUSE_YOUR_MEMBERSHIP = function IF_YOU_WOULD_LIKE_TO_PAUSE_YOUR_MEMBERSHIP(strictLocalize) {
  return strictLocalize({
    id: "bPUsMv",
    defaultMessage: [{
      "type": 0,
      "value": "Se quiser suspender a subscrição Insider, basta clicar em \"Cancelar subscrição\" no separador \"Subscrição Insider\" das definições de conta. Aí, terá a opção de suspender a sua subscrição."
    }]
  });
};